import React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ProductVersionsProp {
  versions: string[];
  handleVersion: any;
  disabled?: boolean;
  maxVersions?: number;
}

export default function ProductVersions({
  versions,
  handleVersion,
  disabled,
  maxVersions = 3,
}: ProductVersionsProp) {
  const [inputs, setInputs] = useState<string[]>(versions);
  const { t } = useTranslation();
  const limit = Math.min(maxVersions ?? 3, 3);

  useEffect(() => {
    if (versions.length > 0) {
      setInputs(versions);
    } else {
      setInputs(['']);
    }
  }, []);

  const getVersionPlaceholder = (index: number) => {
    if (index === 1) return t('product.editProduct.secondVersion');
    if (index === 2) return t('product.editProduct.thirdVersion');
    return '';
  };

  const removeVersion = (index: number) => {
    const newVersionArray = [...inputs];
    newVersionArray.splice(index, 1);
    if (newVersionArray.length === 0) {
      newVersionArray.push('');
    }
    setInputs(newVersionArray);
    handleVersion(newVersionArray);
  };

  const addVersion = () => {
    const newVersionArray = inputs.concat('');
    setInputs(newVersionArray);
    handleVersion(newVersionArray);
  };

  const handleChange = (event: any, index: any) => {
    const { value } = event.target;
    const onChangeValue = [...inputs];
    onChangeValue[index] = value;
    setInputs(onChangeValue);
    handleVersion(onChangeValue);
  };

  return (
    <div className="list-builder">
      {inputs.map((version, index) => (
        <div className="col-sm-9 list-item" key={index}>
          <div className="list-input">
            <input
              value={version}
              className="form-control"
              type="text"
              maxLength={255}
              disabled={disabled}
              onChange={(event) => handleChange(event, index)}
              placeholder={getVersionPlaceholder(index)}
            />
          </div>
          {!disabled ? (
            <button
              className="icon-btn"
              onClick={() => removeVersion(index)}
              type="button"
            >
              <i className="icon fas fa-times"></i>
            </button>
          ) : null}
        </div>
      ))}
      <div className="col-sm-4 text-start">
        {!disabled && inputs.length < limit ? (
          <button
            className="btn add-btn text-end"
            type="button"
            onClick={addVersion}
          >
            <i className="icon fas fa-plus"></i>
            <span>{t('common.button.addVersion')}</span>
          </button>
        ) : null}
      </div>
    </div>
  );
}
